import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'

/** Insignia editorial «Importado» — misma apariencia en todos los pickers. */
export function ImportedTokenBadge({ className }: { className?: string }) {
  return (
    <span className={className ?? 'nm-mobile-simple__picker-imported-badge'}>
      {nutrimaticLabels.mobileSimple.pickerImportedBadge}
    </span>
  )
}
